import React from 'react';
import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useNewProjectUrl } from 'domain/shared/newProject';
import ProjectBreadcrumbs from './ProjectFinanceBreadcrumbs';

const BillingBreadcrumbs = ({
  children = null,
  id,
}: {
  children?: React.ReactNode | React.ReactNode[] | null;
  id: string;
}) => {
  const { getFinanceUrl } = useNewProjectUrl();
  return (
    <ProjectBreadcrumbs projectId={id}>
      <ListBreadcrumbItem entity="Billing" link={getFinanceUrl(id!)} />
      {children}
    </ProjectBreadcrumbs>
  );
};

export default BillingBreadcrumbs;
